import { sendAnswerEvent, sendCompleteEvent } from "./ga";
import { Action, QuestionQuestionSelect, State } from "./type";

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case "ANSWER":
            sendAnswerEvent(action.questionNo);

            state.answers = state.answers.filter(
                (answer) => answer.questionNo != action.questionNo
            );

            state.answers.push({
                questionNo: action.questionNo,
                answer: action.answer,
                target1: action.question_select.target1,
                target2: action.question_select.target2,
                target3: action.question_select.target3,
                target4: action.question_select.target4,
            });

            if (action.nextQuestionNo === 9999) {
                return {
                    ...state,
                    isBackState: false,
                    currentQuestionNo: action.questionNo, // 次ページに遷移させない
                    answers: state.answers,
                    finish: true,
                };
            } else if (action.nextQuestionNo === 777) {
                //@ts-ignore
                const gender: "男性" | "女性" = state.answers
                    .find((a) => a.answer.toString().match(/男性|女性/))
                    .answer.toString();
                const currentQuestionNo = gender == "男性" ? 25 : 21;

                return {
                    ...state,
                    isBackState: false,
                    currentQuestionNo, // 次ページに遷移させない
                    answers: state.answers,
                    displayQuestionNo: state.displayQuestionNo + 1,
                };
            } else {
                return {
                    ...state,
                    isBackState: false,
                    currentQuestionNo: action.nextQuestionNo,
                    answers: state.answers,
                    displayQuestionNo: state.displayQuestionNo + 1,
                };
            }
        case "MULTI_ANSWER":
            sendAnswerEvent(action.questionNo);

            state.answers = state.answers.filter(
                (answer) => answer.questionNo != action.questionNo
            );

            action.answers.map((answer: QuestionQuestionSelect) => {
                state.answers.push({
                    questionNo: action.questionNo,
                    answer: answer.text,
                    target1: answer.target1,
                    target2: answer.target2,
                    target3: answer.target3,
                    target4: answer.target4,
                });
            });

            if (action.nextQuestionNo == 9999) {
                sendCompleteEvent();
                return {
                    ...state,
                    isBackState: false,
                    currentQuestionNo: action.questionNo, // 次ページに遷移させない
                    answers: state.answers,
                    finish: true,
                };
            } else if (action.nextQuestionNo === 777) {
                //@ts-ignore
                const gender: "男性" | "女性" = state.answers
                    .find((a) => a.answer.toString().match(/男性|女性/))
                    .answer.toString();
                const currentQuestionNo = gender == "男性" ? 25 : 21;

                return {
                    ...state,
                    isBackState: false,
                    currentQuestionNo, // 次ページに遷移させない
                    answers: state.answers,
                    displayQuestionNo: state.displayQuestionNo + 1,
                };
            } else {
                return {
                    ...state,
                    isBackState: false,
                    currentQuestionNo: action.nextQuestionNo,
                    answers: state.answers,
                    displayQuestionNo: state.displayQuestionNo + 1,
                };
            }
        case "FETCH_INIT":
            return { ...state, loading: true };
        case "FETCH_SUCCESS":
            return { ...state, loading: false };
        case "FETCH_FAILURE":
            return { ...state, loading: false, finish: false };
        case "SET_LAST_ANSWER":
            return { ...state, lastAnswer: action.lastAnswer };
        case "BACK_PREVIOUS_QUESTION":
            if (state.displayQuestionNo === 1) {
                return { ...state, isFirstView: true };
            }

            const answeredNumber = state.answers.map((a) => a.questionNo);

            const previousQuestionNo =
                answeredNumber.length == 0 ? 1 : answeredNumber.slice(-1)[0];

            const answers = state.answers.filter(
                (answer) => answer.questionNo != previousQuestionNo
            );

            return {
                ...state,
                isBackState: true,
                currentQuestionNo: previousQuestionNo,
                displayQuestionNo: state.displayQuestionNo - 1,
                answers,
            };
        case "CLOSE_FIRST_VIEW":
            return { ...state, isFirstView: false };
        case "OPEN_FIRST_VIEW":
            return { ...state, isFirstView: true };
        default:
            return state;
    }
};

export default reducer;
